import { FormCard } from '@portal_components/components/FormCard';
import { FormTextInput } from '@portal_components/components/FormTextInput';
import { Group } from '../../types';

interface CustomerAddressTabProps {
  readonly: boolean;
}
export const CustomerAddressTab = ({ readonly }: CustomerAddressTabProps) => {
  return (
    <FormCard columns={2}>
      <FormTextInput<Group> title="Property Name" name="address.addressName" readonly={readonly} mandatory />
      <FormTextInput<Group> title="Address Line 1" name="address.addressLine1" readonly={readonly} mandatory />
      <FormTextInput<Group> title="Address Line 2" name="address.addressLine2" readonly={readonly} />
      <FormTextInput<Group> title="Address Line 3" name="address.addressLine3" readonly={readonly} />
      <FormTextInput<Group> title="Town" name="address.town" readonly={readonly} mandatory />
      <FormTextInput<Group> title="County" name="address.county" readonly={readonly} mandatory />
      <FormTextInput<Group> title="Postcode" name="address.postcode" readonly={readonly} mandatory />
    </FormCard>
  );
};
